import React, {useCallback, useEffect, useState} from "react";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {UserApiCalls} from "../../apis/UserApiCalls";
import YuJaGeneralAlert from "../../components/modals/YuJaGeneralAlert";
import YuJaButton from "../../components/standardization/YuJaButton";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import {
    ACTIVITY_TYPE_PLACEHOLDER,
    ATTENDANCE,
    BUTTON,
    CREATE_ATTENDANCE_TEXT,
    CREATE_POLL,
    DEFAULT_GET_READY_ALL_TIME_LIMIT,
    DEFAULT_GET_READY_TIME_LIMIT,
    DEFAULT_POINTS,
    DEFAULT_POLL_LMS_SYNC,
    DEFAULT_POLL_MAX_ATTEMPTS,
    DEFAULT_POLL_RECORD_ATTEMPTS,
    DEFAULT_POLL_REQUIRED_NAME,
    DEFAULT_POLL_SHOW_CORRECT_ANS,
    DEFAULT_POLL_TIME_LIMIT,
    DEFAULT_ROWS_PER_PAGE,
    DEFAULT_TIME_LIMIT,
    DELETE_ACTIVITY,
    DELETE_POLL_MODAL_BODY,
    DRAFT_STATUS,
    MODAL_CANCEL_TEXT,
    MODAL_DELETE_TEXT,
    POLL_KEY,
    POLL_SHARE_MODE,
    POLL_SHARE_MODE_ACCESSOR,
    POLL_SORT_KEY,
    POLL_STATE,
    POLL_TEXT,
    POLL_TITLE,
    POLL_TYPE,
    POLL_TYPE_ACCESSOR,
    PPT_INSERT_PAGE_VIEW,
    PPT_POLLS_DATE_ACCESSOR,
    PPT_POLLS_TABLE_ACTION_HEADER,
    PPT_POLLS_TABLE_DATE_HEADER,
    PPT_POLLS_TABLE_QUESTION_HEADER,
    PPT_POLLS_TABLE_SELECT_HEADER,
    PPT_POLLS_TABLE_TITLE_HEADER,
    PPT_POLLS_TABLE_TYPE_HEADER,
    PPT_POLLS_TBLE_STATUS_HEADER,
    PPT_WEBVIEW_REFRESH_BUTTON,
    SELECT_TEXT,
    SURVEY,
    TOTAL_QUESTIONS,
    USER_SETTINGS
} from "../../utils/constants";
import {
    getDefaultUserSettings,
    isShareByQuestionActivity,
    notifyError,
    removePrefix,
    removePrefixNew,
} from "../../utils/helpers";
import {
    DELETE_ACTIVE_POLL_ERROR,
    INSERT_SLIDE_FAIL,
    RELEASE_INVALID_POLL_ERROR
} from "../../utils/toast-message-constants";
import PollSearchForm from "../ManagePollsPage/PollSearchForm";
import addingSlides from "./animations/addingSlides_PowerPoint.json";
import styles from "./PPTPollsPage.module.css";
import PPTPollsTable from "./PPTPollsTable";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import PPTInsertOptionsView from "./PPTInsertOptionsView";
import {useLocation} from "react-router-dom";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import {LTIApiCalls} from "../../apis/LTIApiCalls";
import {ReactComponent as INFO} from "../../images/info_light_purple.svg";
import {ReactComponent as CLOSE} from "../../images/modal_close.svg";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {Button} from "@base-ui/react/button";


export default function PPTPollsPage() {
    const {parseToken, goCreatePollPage, goCreateAttendancePage} = usePPTWebView();
    const {loadUser} = UserApiCalls();
    const {warmUpBrowser, takeScreenshotsNew, checkAppRunning} = ReportApiCalls();
    let {embedActivity, isLMSAuthorized} = LTIApiCalls();
    const {
        copyPollToUser,
        softDeletePublishedPoll,
        softDeleteDraftPoll,
        updatePollDetails,
        getPollsPPT,
        publishPoll
    } = PollApiCalls();

    const location = useLocation();

    const [setHasClosed, getHasClosed] = useLocalStorageNew("PPT_TOP_BANNER_HAS_CLOSED", false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [dataReady, setDataReady] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [selectedPoll, setSelectedPoll] = useState({});
    const [data, setData] = useState([]);
    const [pageIndex, setPageIndex] = useState(0);
    const [filter, setFilter] = useState({mode: [POLL_TEXT]});

    const [pollKey, setPollKey] = useState("");
    const [pollUniqueCode, setPollUniqueCode] = useState("");
    const [pollType, setPollType] = useState("");
    const [loadDate, setLoadDate] = useState(new Date());

    const [userSettings, setUserSettings] = useState(getDefaultUserSettings());

    const [pageView, setPageView] = useState(PPT_INSERT_PAGE_VIEW.ACTIVITY_LIST_VIEW);
    const [bannerOpened, setBannerOpened] = useState(() => {
        return !getHasClosed();
    });

    const options = {
        loop: true,
        autoplay: true,
        animationData: addingSlides,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
            // viewBox: "200 200 320 320",
            // filterSize: {
            // width: '200%',
            // height: '200%',
            // x: '-50%',
            // y: '-50%',
            // }
        }
    };

    useEffect(() => {
        loadPolls();
        if (!!location?.state?.activity) {
            let {pollKey, pollCode, pollType} = location.state.activity;
            setFilter({mode: pollType === POLL_TYPE.ATTENDANCE ? [ATTENDANCE] : [POLL_TEXT]});
            if (!!pollKey && !!pollCode) {
                setSelectedPoll({
                    ...location.state.activity,
                    pollKey: `P#${pollKey}`,
                    pollSortKey: `PUB#UC#${pollCode}`
                });
                setPageView(PPT_INSERT_PAGE_VIEW.ACTIVITY_RELEASE_OPTION_VIEW);
            }
        } else {
            warmUpBrowser("", "", "").then();
        }


    }, []);


    useEffect(() => {
        const {institutionId, userId} = parseToken();
        loadUser(institutionId, userId).then(res => {
            const {settings = {}} = res;

            if (!settings.hasOwnProperty(USER_SETTINGS.QUESTION_DURATION)) {
                settings[USER_SETTINGS.QUESTION_DURATION] = DEFAULT_TIME_LIMIT;
            }
            settings[USER_SETTINGS.QUESTION_DURATION] = parseInt(settings[USER_SETTINGS.QUESTION_DURATION], 10);
            if (!settings.hasOwnProperty(USER_SETTINGS.QUESTION_POINTS)) {
                settings[USER_SETTINGS.QUESTION_POINTS] = DEFAULT_POINTS;
            }
            settings[USER_SETTINGS.QUESTION_POINTS] = parseInt(settings[USER_SETTINGS.QUESTION_POINTS], 10);
            if (!settings.hasOwnProperty(USER_SETTINGS.QUESTION_COUNTDOWN)) {
                settings[USER_SETTINGS.QUESTION_COUNTDOWN] = DEFAULT_GET_READY_TIME_LIMIT;
            }
            settings[USER_SETTINGS.QUESTION_COUNTDOWN] = parseInt(settings[USER_SETTINGS.QUESTION_COUNTDOWN], 10);
            if (!settings.hasOwnProperty(USER_SETTINGS.POLL_DURATION)) {
                settings[USER_SETTINGS.POLL_DURATION] = DEFAULT_POLL_TIME_LIMIT;
            }
            settings[USER_SETTINGS.POLL_DURATION] = parseInt(settings[USER_SETTINGS.POLL_DURATION], 10);
            if (!settings.hasOwnProperty(USER_SETTINGS.POLL_COUNTDOWN)) {
                settings[USER_SETTINGS.POLL_COUNTDOWN] = DEFAULT_GET_READY_ALL_TIME_LIMIT;
            }
            settings[USER_SETTINGS.POLL_COUNTDOWN] = parseInt(settings[USER_SETTINGS.POLL_COUNTDOWN], 10);
            if (!settings.hasOwnProperty(USER_SETTINGS.POLL_REQUIRED_NAME)) {
                settings[USER_SETTINGS.POLL_REQUIRED_NAME] = DEFAULT_POLL_REQUIRED_NAME;
            }
            settings[USER_SETTINGS.POLL_REQUIRED_NAME] = (settings[USER_SETTINGS.POLL_REQUIRED_NAME] === "true");
            if (!settings.hasOwnProperty(USER_SETTINGS.POLL_SHOW_CORRECT_ANS)) {
                settings[USER_SETTINGS.POLL_SHOW_CORRECT_ANS] = DEFAULT_POLL_SHOW_CORRECT_ANS;
            }
            settings[USER_SETTINGS.POLL_SHOW_CORRECT_ANS] = (settings[USER_SETTINGS.POLL_SHOW_CORRECT_ANS] === "true");
            if (!settings.hasOwnProperty(USER_SETTINGS.POLL_LMS_SYNC)) {
                settings[USER_SETTINGS.POLL_LMS_SYNC] = DEFAULT_POLL_LMS_SYNC;
            }
            if (!settings.hasOwnProperty(USER_SETTINGS.POLL_RECORD_ATTEMPTS)) {
                settings[USER_SETTINGS.POLL_RECORD_ATTEMPTS] = DEFAULT_POLL_RECORD_ATTEMPTS;
            }
            if (!settings.hasOwnProperty(USER_SETTINGS.POLL_MAX_ATTEMPTS)) {
                settings[USER_SETTINGS.POLL_MAX_ATTEMPTS] = DEFAULT_POLL_MAX_ATTEMPTS;
            }
            settings[USER_SETTINGS.POLL_MAX_ATTEMPTS] = parseInt(settings[USER_SETTINGS.POLL_MAX_ATTEMPTS], 10);
            setUserSettings(settings);
        })
    }, []);

    const loadPolls = () => {
        setDataReady(false);
        getPollsPPT().then((res) => {
            const sortedArr = res
                .filter(p => !!p.pollType && [POLL_TYPE.ATTENDANCE, POLL_TYPE.MERGED_POLL].includes(p.pollType))
                .filter(i => i.pollShareMode !== POLL_SHARE_MODE.SCHEDULE)
                .filter(p => p.isValid !== false)
                .sort((a, b) => a.updatedTimeSK.localeCompare(b.updatedTimeSK))
                .reverse();
            setData(sortedArr);
            setLoadDate(new Date());
        }).finally(() => {
            setDataReady(true);
        });
    }


    const reload = () => {
        setPageView(PPT_INSERT_PAGE_VIEW.ACTIVITY_LIST_VIEW);
        setSelectedPoll({});
        loadPolls();
    }

    const onSelect = async (poll=null) => {
        if (!!poll) {
            setSelectedPoll(poll);
        } else {
            poll = selectedPoll;
        }
        let {pollType, pollKey, pollSortKey} = poll;

        if (pollType === POLL_TYPE.ATTENDANCE) {
            try {
                setIsAdding(true);
                let authorized = await isLMSAuthorized();
                if (!authorized) {
                    setIsAdding(false);
                    return;
                }

                pollKey = removePrefix(pollKey);
                let pollCode = removePrefixNew(pollSortKey);
                const pollDetails = {};
                pollDetails.pollShareMode = POLL_SHARE_MODE.SHARE_EACH;
                await updatePollDetails(pollKey, pollCode, pollDetails, true);
                let isSuccess = await embedActivity(pollKey, pollCode);
                if (isSuccess) {
                    takeScreenshotsNew(
                        pollKey,
                        pollCode,
                        false,
                        []
                    );
                }

                checkAppRunning(pollKey, pollCode, POLL_SHARE_MODE.SHARE_EACH, pollType, 1).catch(err => {
                    console.log(err);
                    notifyError(INSERT_SLIDE_FAIL.replaceAll(
                        ACTIVITY_TYPE_PLACEHOLDER,
                        pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE : POLL_TEXT
                    ));
                    setIsAdding(false);
                });
            } catch (err) {
                console.log(err);
                setIsAdding(false);
            }
        } else {
            setPageView(PPT_INSERT_PAGE_VIEW.ACTIVITY_RELEASE_OPTION_VIEW);
        }
    }

    const onDuplicate = async (item) => {
        let res;
        if (item[POLL_SORT_KEY] === DRAFT_STATUS) {
            res = await copyPollToUser({
                'pollKey': removePrefixNew(item.pollKey),
                'pollType': item[POLL_TYPE_ACCESSOR]
            });
        } else {
            res = await copyPollToUser({
                'pollKey': removePrefixNew(item.pollKey),
                'pollType': item[POLL_TYPE_ACCESSOR],
                'pollCode': removePrefixNew(item[POLL_SORT_KEY])
            });
        }
        if (!res) {
            return;
        }
        const pollToAdd = {
            pollKey: removePrefix(res.pollKeys.substring(1, res.pollKeys.length - 1)),
            pollShareMode: POLL_SHARE_MODE.UNKNOWN,
            pollTimeLimit: item.pollTimeLimit ? item.pollTimeLimit : userSettings[USER_SETTINGS.POLL_DURATION],
        };
        let result = await publishPoll(pollToAdd, true);
        result = !!result ? result : {};
        let {published={}} = result;
        published = !!published ? published : {};
        const {isValid, pk, sk, totalQuestions}=published;

        if (!!isValid) {
            takeScreenshotsNew(
                removePrefixNew(pk),
                removePrefixNew(sk),
                isShareByQuestionActivity(published),
                Array.from({ length: totalQuestions }, (_, i) => ({ serialNo: i + 1 }))
            );
        }

        loadPolls();
    }

    const onDeleteDraft = (pollKey, pollType) => {
        setPollKey(pollKey);
        setPollType(pollType);
        setShowDeleteModal(true);
    }


    const onDeletePublished = (pollKey, uniqueCode, pollType, poll) => {
        setPollKey(pollKey);
        setPollUniqueCode(uniqueCode);
        setPollType(pollType);
        const pollState = poll?.pollState;
        const pollShareMode = poll?.pollShareMode;
        const liveQuestionTime = poll?.liveQuestionTime;
        const timeLimit = poll?.pollTimeLimit;
        const start = new Date(poll?.startTime);
        const end = new Date(poll?.endTime);


        const now = new Date();
        if ((pollShareMode === POLL_SHARE_MODE.SCHEDULE && !!start && start < now && !!end && now < end) ||
            (pollShareMode === POLL_SHARE_MODE.SHARE_ALL && !!pollType && !!liveQuestionTime &&
                ((pollType === SURVEY && pollState === POLL_STATE.SHARED_ALL) || ((+now) < (liveQuestionTime + (timeLimit * 1000))))
            )) {
            notifyError(DELETE_ACTIVE_POLL_ERROR);
            return;
        }
        setShowDeleteModal(true);
        // let pollCode = uniqueCode.substring(7);
        // const res = await softDeletePublishedPoll(key, pollCode, pollType);
        // if (res.success) {
        //     getPollInformation(pageIndex);
        // }
    }


    const deletePollConfig = {
        title: DELETE_ACTIVITY,
        okText: MODAL_DELETE_TEXT,
        cancelText: MODAL_CANCEL_TEXT,
        submit: () => {
            handleDelete();
        },
        close: () => {
            setShowDeleteModal(false);
        },
    };


    const handleDelete = async () => {
        console.log(pollKey, pollUniqueCode, pollType);
        let key = removePrefixNew(pollKey);
        try {
            setDataReady(false);
            setShowDeleteModal(false);
            if (pollUniqueCode) { // delete published
                const res = await softDeletePublishedPoll(key, pollType);
                if (res.success) {
                    loadPolls();
                }
            } else { // delete draft
                const res = await softDeleteDraftPoll(key, pollType);
                if (res.success) {
                    loadPolls();
                }
            }
        } finally {
            setDataReady(true);
        }
    };


    const columns = [
        {Header: PPT_POLLS_TABLE_DATE_HEADER, accessor: PPT_POLLS_DATE_ACCESSOR, width: 130},
        {Header: PPT_POLLS_TABLE_TITLE_HEADER, accessor: POLL_TITLE, width: 250},
        {Header: PPT_POLLS_TABLE_TYPE_HEADER, accessor: POLL_TYPE_ACCESSOR, width: 110},
        {Header: PPT_POLLS_TABLE_QUESTION_HEADER, accessor: TOTAL_QUESTIONS, width: 90},
        {Header: PPT_POLLS_TBLE_STATUS_HEADER, accessor: POLL_SHARE_MODE_ACCESSOR, width: 180},
        {Header: PPT_POLLS_TABLE_ACTION_HEADER, accessor: POLL_KEY, width: 90, id: 'action'}
    ];

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    const timeFormatter = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',   // Ensures two digits (e.g., 02)
        minute: '2-digit',
        second: '2-digit',
        hour12: true,      // Ensures AM/PM
    });


    const handleSubmit = useCallback(({...filterObj}) => {
        setFilter(filterObj);
        setPageIndex(0);

    }, []);

    if (pageView === PPT_INSERT_PAGE_VIEW.ACTIVITY_RELEASE_OPTION_VIEW) {
        return (
            <PPTInsertOptionsView
                reload={reload}
                selectedPoll={selectedPoll}
                setPageView={setPageView}
            />
        );
    }


    return (
        <div className={styles.tableParentContainer} id="manage-poll-page-container">
            <YuJaGeneralAlert
                show={showDeleteModal}
                setModalShow={setShowDeleteModal}
                content={DELETE_POLL_MODAL_BODY}
                config={deletePollConfig}
                AlertType={MODAL_DELETE_TEXT}
            />

            <div
                style={{
                    flex: 1, position: "relative", minHeight: 500, width: "100%",
                    display: "flex", flexDirection: "column",
                    padding: 10, gap: 10,
                    backgroundColor: "#f7f7f7"
                }}
            >

                {dataReady &&
                    <>
                        {bannerOpened &&
                            <div className={styles.firstBanner}>
                                <INFO style={{flexShrink: 0, alignSelf: "start"}}/>
                                <span style={{flex: 1, minHeight: 0}}>
                                    {"To get started, select a poll or attendance to insert into your presentation. Alternatively, create a new activity to add to your presentation."}
                                </span>
                                <div
                                    tabIndex={0}
                                    role={BUTTON}
                                    aria-label={"Close Banner"}
                                    className={styles.bannerClose}
                                    onClick={() => {
                                        setBannerOpened(false);
                                        setHasClosed(true);
                                    }}
                                >
                                    <CLOSE/>
                                </div>
                            </div>
                        }


                        <div className={styles.titleCard}>
                            <div className={styles.column}>
                                <span className={styles.title} style={{fontSize: 16, marginBottom: 5}}>
                                    {"Create New Activity"}
                                </span>
                                <span className={styles.description}>
                                    {"Add a new poll or attendance to insert into your presentation."}
                                </span>
                            </div>

                            <div style={{flex: 1}}/>

                            <div className={styles.row} style={{gap: 10}}>
                                    <span
                                        tabIndex={0}
                                        role={"button"}
                                        className={styles.navigateButton}
                                        onClick={goCreatePollPage}
                                    >{CREATE_POLL}</span>
                                    <span
                                        tabIndex={0}
                                        role={"button"}
                                        className={styles.navigateButton}
                                        onClick={goCreateAttendancePage}
                                    >{CREATE_ATTENDANCE_TEXT}</span>
                                </div>
                        </div>

                        <div className={styles.tableCardContainer}>
                            <div className={styles.row} style={{fontSize: 13}}>
                                    <span>
                                        <span>{"Updated at: "}</span>
                                        <span style={{color: "#6B6B6B", marginRight: 3}}>
                                            {`${dateFormatter.format(loadDate)}, ${timeFormatter.format(loadDate)}.`}
                                        </span>
                                    </span>

                                <Button tabIndex={0} role={"link"} onClick={loadPolls}
                                     className={styles.link}>{PPT_WEBVIEW_REFRESH_BUTTON}</Button>
                            </div>
                            <PollSearchForm handleSubmit={handleSubmit} isPPT={true} filter={filter}
                                            setSelectedPoll={setSelectedPoll}/>
                            {/*<div className={styles.row}>*/}
                            {/*    <span*/}
                            {/*        className={styles.description}*/}
                            {/*        style={{flex: 1}}*/}
                            {/*    >{PPT_WEBVIEW_POLL_TABLE_GUIDE_LINE.replaceAll(*/}
                            {/*        ACTIVITY_TYPE_PLACEHOLDER,*/}
                            {/*        filter.mode.includes(ATTENDANCE)*/}
                            {/*            ? `an ${deCapitalizeWord(ATTENDANCE)}`*/}
                            {/*            : `a ${deCapitalizeWord(POLL_TEXT)}`*/}
                            {/*    )}</span>*/}
                            {/*        <YuJaButton style={{padding: "5px 10px", width: 80, height: 40}} onClick={loadPolls}*/}
                            {/*                    disabled={!dataReady}>{PPT_WEBVIEW_REFRESH_BUTTON}</YuJaButton>*/}
                            {/*</div>*/}
                            <PPTPollsTable
                                columns={columns}
                                data={!!data && data.length !== 0 ? data : []}
                                setData={setData}
                                pageIdx={pageIndex}
                                globalFilterObj={filter}
                                setSelectedPoll={setSelectedPoll}
                                selectedPoll={selectedPoll}
                                onDuplicate={onDuplicate}
                                onDeleteDraft={onDeleteDraft}
                                onDeletePublished={onDeletePublished}
                                onSelect={onSelect}
                            />
                        </div>


                    </>
                }

                {!dataReady && (
                    <>
                        <div className={styles.row} style={{gap: 10, width: "100%"}}>
                            <Skeleton borderRadius={4} height={36} inline={true}
                                      width={120}
                                      className={styles.skeletonBodyCell}
                                      containerClassName={styles.skeletonBodyCellWrapper}
                            />
                            <Skeleton borderRadius={4} height={36} inline={true}
                                      width={120}
                                      className={styles.skeletonBodyCell}
                                      containerClassName={styles.skeletonBodyCellWrapper}
                            />

                            <div style={{flexShrink: 1, width: 70}}/>
                            <div style={{flex: 1, minWidth: 200}}>
                                <Skeleton borderRadius={4} height={36} inline={true}
                                          className={styles.skeletonBodyCell}
                                          containerClassName={styles.skeletonBodyCellWrapper}


                                />
                            </div>


                            <Skeleton borderRadius={4} height={36} inline={true}
                                      width={80}
                                      className={styles.skeletonBodyCell}
                                      containerClassName={styles.skeletonBodyCellWrapper}
                            />
                        </div>
                        <div className={styles.row} style={{gap: 10, width: "100%"}}>
                            <Skeleton borderRadius={4} height={36} inline={true}
                                      width={300}
                                      className={styles.skeletonBodyCell}
                                      containerClassName={styles.skeletonBodyCellWrapper}
                            />


                            <div style={{flex: 1}}/>



                            <Skeleton borderRadius={4} height={36} inline={true}
                                      width={130}
                                      className={styles.skeletonBodyCell}
                                      containerClassName={styles.skeletonBodyCellWrapper}
                            />
                        </div>
                        <div className={styles.skeletonTableContainer}>
                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                <div className={styles.skeletonHeaderContainer}>
                                    <div className={styles.skeletonHeaderCell}>{PPT_POLLS_TABLE_DATE_HEADER}</div>
                                    <div className={styles.skeletonHeaderCell} style={{
                                        width: "100%",
                                        height: "100%",
                                        justifyContent: "start",
                                        alignItems: "center"
                                    }}>{PPT_POLLS_TABLE_TITLE_HEADER}</div>
                                    <div className={styles.skeletonHeaderCell}>{PPT_POLLS_TABLE_QUESTION_HEADER}</div>
                                    <div className={styles.skeletonHeaderCell}>{PPT_POLLS_TBLE_STATUS_HEADER}</div>
                                    <div
                                        className={styles.skeletonActionHeaderCell}>{PPT_POLLS_TABLE_ACTION_HEADER}</div>
                                </div>
                                <div className={styles.skeletonBodyContainer}>
                                    {Array.apply(null, Array(DEFAULT_ROWS_PER_PAGE)).map((_, idx) => {
                                        return (<div key={idx} className={styles.skeletonBodyRow}>
                                            <Skeleton borderRadius={10} height={20} inline={true}
                                                      width={`${6 + Math.random()}vw`} className={styles.skeletonBodyCell}
                                                      containerClassName={styles.skeletonBodyCellWrapper} style={{
                                                display: "flex",
                                                width: "100%",
                                                height: "100%",
                                                justifyContent: "start",
                                                alignItems: "center"
                                            }}/>
                                            <Skeleton borderRadius={10} height={20} inline={true}
                                                      width={`${3 + (Math.random() * 7)}vw`}
                                                      className={styles.skeletonBodyCell}
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                            <Skeleton borderRadius={10} height={20} inline={true}
                                                      width={`${idx % 2 === 0 ? 3.5 : 3}vw`}
                                                      className={styles.skeletonBodyCell}
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                            <Skeleton borderRadius={10} height={20} inline={true}
                                                      width={`${2 + (Math.random() * 3)}vw`}
                                                      className={styles.skeletonBodyCell}
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                            <Skeleton borderRadius={10} height={20} inline={true} width="2vw"
                                                      className={styles.skeletonActionBodyCell}
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                        </div>)
                                    })}
                                </div>
                            </SkeletonTheme>
                        </div>
                    </>
                )}
            </div>

            {selectedPoll && !!Object.entries(selectedPoll).length &&
                <div className={styles.footer}>
                    {/*<span>{JSON.stringify(selectedPoll)}</span>*/}
                    {/*<span>{JSON.stringify(filter)}</span>*/}
                    <YuJaButton
                        type={"secondary"}
                        style={{padding: "5px 10px", width: 130}}
                        onClick={() => setSelectedPoll({})}
                    >
                        {MODAL_CANCEL_TEXT}
                    </YuJaButton>

                    <YuJaTooltip
                        placement={"top"}
                        disabled={selectedPoll.pollSortKey !== "Draft"}
                        text={RELEASE_INVALID_POLL_ERROR}
                        tooltipStyle={{maxWidth: 250}}
                    >
                        <YuJaButton
                            style={{padding: "5px 10px", width: 130}}
                            onClick={onSelect}
                            disabled={selectedPoll.pollSortKey === "Draft" || isAdding}
                        >
                            {SELECT_TEXT}
                        </YuJaButton>
                    </YuJaTooltip>


                </div>
            }

        </div>
    );
}